// extracted by mini-css-extract-plugin
module.exports = {"container":"ResetPasswordPage_container__3KvzX","success":"ResetPasswordPage_success__1Fo_k","link":"ResetPasswordPage_link__-X9g6"};